// cSpell:ignore xyflow
import { type NodeProps, type Node } from "@xyflow/react";
import { CircleSlash } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { GraphNodeData } from "../utils/buildGraph";
import { NodeShell } from "./NodeShell";

export function NoBonusNode({ data }: NodeProps<Node<GraphNodeData>>) {
  const { t } = useTranslation();
  const isElseEmpty = data.label === "Aucune prime";

  return (
    <NodeShell
      variant="noBonus"
      icon={CircleSlash}
      title={
        isElseEmpty
          ? t("step5Validation.noBonus.title")
          : t("step5Validation.noBranch.nothing")
      }
      hideBottomHandle
    >
      <p className="text-center text-zinc-600 dark:text-zinc-400">
        {isElseEmpty
          ? t("step5Validation.noBonus.subtitle")
          : t("step5Validation.noBranch.subtitle", "Aucune action déclenchée")}
      </p>
    </NodeShell>
  );
}
